import React from 'react'
import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import { Acf } from '../../../../../wp_types'
import { Link } from '../../../../cms/blocks/types.gen'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { TemplateState } from '../../../../cms/page/types.gen'
import { CustomBlock } from '../../../../wordpress/types_and_parser/custom_blocks.gen'
import { Block } from '../../../../wordpress/types_and_parser/standard_blocks.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { ExtraImages } from '../../../utils/extra_images.mod'
import { CustomBlockData } from '../types.mod'

export type BSLQuoteBlockProps = {
  image?: Acf.ImageArray
  image_alt?: string
  text: string
  title: string
  subtitle: string
  link?: Link | null
}

export type BSLQuoteBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  container_classname: string
  title_classname: string
  subtitle_classname: string
  footer_classname: string
  footer_inner_classname: string
  figure_classname: string
  clickable_classname: string
}>

export function BSLQuoteBlock<customBlockData, extra_images>(
  props: BSLQuoteBlockProps,
  options?: { style?: BSLQuoteBlockStyle; key?: string }
): IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
> {
  return (s: TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: _ => (
        <section
          className={getClassName(options, 'block_classname', 'block')}
          key={options && options.key ? options.key : ''}
        >
          <div className={getClassName(options, 'inner_classname', 'block__inner')}>
            <div className={getClassName(options, 'container_classname', '')}>
              <div className="text--styled">
                <blockquote>
                  <p>{props.text}</p>
                </blockquote>
              </div>
              <footer className={getClassName(options, 'footer_classname', '')}>
                <div className={getClassName(options, 'footer_inner_classname', '')}>
                  {props.image ? (
                    <figure>
                      <img
                        src={props.image.sizes.quote}
                        alt={props.image_alt}
                        className={getClassName(options, 'figure_classname', '')}
                      />
                    </figure>
                  ) : null}
                  <div>
                    <p className={getClassName(options, 'title_classname', '')}>{props.title}</p>
                    {props.subtitle && (
                      <p className={getClassName(options, 'subtitle_classname', '')}>{props.subtitle}</p>
                    )}
                    {props.link && (
                      <a
                        href={props.link.url}
                        target={props.link.target}
                        className={getClassName(options, 'clickable_classname', '')}
                      >
                        {props.link.title}
                      </a>
                    )}
                  </div>
                </div>
              </footer>
            </div>
          </div>
        </section>
      )
    })
}
